<template>
  <div id="bascInfo">
    <headNav>
      <div slot="headNavText">{{$t('message.basc_info')}}</div>
    </headNav>
    <div class="container">
      <div class="bascInfoBox">
        <div>
          <div class="circle circle1">01</div>
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
        </div>
        <div class="scsf">
          <div>{{$t('message.basc_info_rz')}}</div>
          <div>{{$t('message.basc_info_rz_tips')}}</div>
        </div>
        <div class="bascInfoContent">
                    <div class="form_item">
                      <div class="form_label"><span>*</span>{{$t('message.fullName')}}</div>
                      <van-field v-model="infos.name" :placeholder="$t('message.ipt_u_xm')"
                                 @blur="isNull(tips_name,infos.name,'tips_name')"/>
                    </div>
                    <div class="form_item">
                      <div class="form_label"><span>*</span>{{$t('message.ID')}}</div>
                      <van-field v-model="infos.idCard" :placeholder="$t('message.th_yys_qsrsfz')" @blur="checkID"/>
                    </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.age')}}</div>
            <van-field v-model="infos.birthDate" :placeholder="$t('message.ipt_u_bir')" right-icon="arrow-down"
                       @focus="showdate"
                       readonly/>
          </div>

          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.gender')}}</div>
            <div>
              <van-radio-group v-model="infos.sex" style="display: flex;justify-content: space-between">
                <div class="radio_item" style="margin-right: 5px">
                  <img src="../../../assets/images/3x/male.png" alt="">
                  <van-radio :name="nan"></van-radio>
                </div>
                <div class="radio_item" style="margin-left: 5px">
                  <img src="../../../assets/images/3x/Female.png" alt="">
                  <van-radio :name="nv"></van-radio>
                </div>
              </van-radio-group>
            </div>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.education')}}</div>
            <van-field v-model="infos.edu" :placeholder="$t('message.ipt_u_edu')" right-icon="arrow-down"
                       @focus="showMarrey('edu')"
                       readonly/>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.marriage')}}</div>
            <van-field v-model="infos.marriey" :placeholder="$t('message.ipt_u_marr')" right-icon="arrow-down"
                       @focus="showMarrey('marriey')" readonly/>
          </div>
          <div class="form_item">
            <div class="form_label"><span>*</span>{{$t('message.income')}}</div>
            <van-field v-model="infos.income" :placeholder="$t('message.ipt_u_income')" right-icon="arrow-down"
                       @focus="showMarrey('income')" readonly/>
          </div>
          <div class="form_item">
            <div class="form_label" style="display: flex;align-items: center;justify-content: space-between">
              <div><span>*</span>FaceBook</div>
              <div>
                <div style="font-size: 0.35rem;font-weight: 500;text-decoration: underline;color: rgb(255 125 123)"
                     @click="showImageTRUE">{{$t('message.get_fb_link')}}
                </div>
              </div>
            </div>
            <van-field v-model="infos.facebook" placeholder="FaceBook" @blur="iptFacebook"/>
          </div>
          <div class="form_item" v-if="defat_country=='VN'">
            <div class="form_label"><span>*</span>Zalo</div>
            <van-field v-model="infos.zalo" placeholder="Zalo" type="digit" @blur="isNull(tips_zalo,infos.zalo,'tips_zalo')"/>
          </div>
          <div class="form_item" v-if="defat_country=='TH'">
            <div class="form_label"><span>*</span>Line</div>
            <van-field v-model="infos.zalo" placeholder="Line" @blur="isNull(tips_zalo,infos.zalo,'tips_zalo')"/>
          </div>
          <van-button type="primary" size="normal" round @click="subPerInfo" :disabled="btnDisabled" v-if="isRest==null"
                      class="btns" block>{{$t('message.jx')}}
          </van-button>
          <van-button type="primary" size="normal" round @click="subPerInfoNext" :disabled="btnDisabled"
                      v-if="isRest!=null" class="btns" block>{{$t('message.jx')}}
          </van-button>
        </div>
      </div>
    </div>
    <!--弹出层-->
    <van-popup v-model="show" position="bottom" :style="{ height: '42%' }">
      <van-picker :columns='itemName' @change="onChange" @cancel="onCancel" :show-toolbar='true'
                  @confirm="onConfirm" :confirm-button-text="$t('message.determine')"
                  :cancel-button-text="$t('message.cancel')"
      />
    </van-popup>
    <van-popup v-model="showDate" position="bottom" :style="{ height: '42%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :columns-order="['day','month', 'year']"
        @cancel="onCancel"
        :show-toolbar='true'
        @confirm="onConfirmDate"
        :confirm-button-text="$t('message.determine')"
        :cancel-button-text="$t('message.cancel')"
      />
    </van-popup>
    <!--    展示facebook获取的样图-->
    <van-image-preview v-model="showImage" :images="defat_country=='VN'?images:images2" :closeable="true">
    </van-image-preview>
  </div>
</template>

<script>
  import {yys_display, zhiyeNews, sassSearchInfo, postUserInfo, postBascInfo, post_facebook} from '../../../ports/port'
  import headNav from "../../HeadNav/headNav";
  import img1 from '@/assets/images/3x/face1.jpg'
  import img2 from '@/assets/images/3x/face2.jpg'
  import img3 from '@/assets/images/3x/face1.png'
  import img4 from '@/assets/images/3x/face2.png'

  export default {
    name: "bascInfo",
    data() {
      return {
        is_go_yys: '',//判断是否去运营商页面 1是显示运营商，0是不显示运营商
        // btnDisabled: true,
        facebookTrue: false,//判断facebook是否填写正确
        minDate: new Date(1970, 0, 1),
        currentDate: new Date(),
        maxDate:'',
        showDate: false,
        show: false,
        middle_value: ['+66'],//zalo输入时的中间值
        zalo_final: '',
        showimgs: false,//弹出层图片显示
        images: [
          img1,
          img2
        ],
        images2: [
          img3,
          img4
        ],
        itemName: '',//每个对象内表单单独的名称
        infoName: '',//每个表单单独的名称
        infos: {
          sex: this.$t('message.male'),//性别
          name: '',
          marriey: '',//婚姻
          edu: '',//学历
          birthDate: "",//出生
          job: '',
          idCard: '',//身份证
          facebook: '',
          zalo: '',
          company: '',//公司
          income: '',//收入
          tel: '',
          city: '',
          address: '',
          userinfo_start_time: '',//开始时间
          userinfo_end_time: ''//结束时间
        },
        baseNews: {
          edu: [],
          marriey: [],
          income: [],
          job: []
        },
        tipIDcard: false,
        tipfb: false,
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        showLoading: false,
        error_border: {
          border: '1px solid red',
          borderRadius: '4px'
        },
        tips_sex: false,
        tips_name: false,
        tips_idCard: false,
        tips_marriey: false,
        tips_edu: false,
        tips_birthDate: false,
        tips_zalo: false,
        tips_income: false,
        zalo_check_tel: '',
        isRest: '',//判断是否审核拒绝，需要重新认证
        radio: '1',
        value: '',
        showImage: false,
        defat_country: this.$Language,
        nan: this.$t('message.male'),
        nv: this.$t('message.Female'),
      }
    },
    mounted() {
      this.maxDate = new Date();
      if(sessionStorage.getItem('birthdate')!=null && sessionStorage.getItem('birthdate')!=''){
        this.currentDate =new Date(sessionStorage.getItem('birthdate'));
        let date = sessionStorage.getItem('birthdate').split('-');
        this.infos.birthDate = date[2]+'-'+date[1]+'-'+date[0];
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      this.infos.userinfo_start_time = Date.now();
      //验证后重新检查个人信息
      this.isRest = sessionStorage.getItem('restRZ');
      if (sessionStorage.getItem('restRZ')) {
        sassSearchInfo({userid: this.tk.userid, orderid: this.$route.query.orderid})
          .then(res => {
            let r = res.data.data;

            this.infos.name = r.truename;
            this.infos.idCard = r.idcard;
            this.infos.birthDate = r.birthdate;

            // this.infos.sex = r.sex;
            r.sex == '男' ? this.infos.sex = this.nan : this.infos.sex = this.nv;
            this.infos.edu = r.education;
            r.is_married == "未知" ? this.infos.marriey = '' : this.infos.marriey = r.is_married;

            this.infos.facebook = r.facebook_url;
            this.infos.zalo = r.zalo;
            this.infos.job = r.occupation;
            this.infos.income = r.income_max;
            this.infos.company = r.unit_name;
            this.infos.tel = r.unit_phone;
            this.infos.city = r.unit_city;
            this.infos.address = r.unit_address;
            this.btnDisabled = false;
          })
          .catch(err => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      }


      yys_display({})
        .then(res => {
          if (res.data.code == 200) {
            this.is_go_yys = res.data.data.yys_is_show;
          }
        })
        .catch(err => {
          this.$store.commit('edit', false);//关闭全局的loading
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        })
      zhiyeNews({})
        .then(res => {

          res.data.data.MaritalStatus.forEach((elem, index) => {
            this.baseNews.marriey.push(elem.vietnamese);
          });
          res.data.data.education.forEach((elem, index) => {
            this.baseNews.edu.push(elem.vietnamese);
          });
          res.data.data.income.forEach((elem, index) => {
            this.baseNews.job.push(elem.vietnamese);
          });
          res.data.data.profession.forEach((elem, index) => {
            this.baseNews.income.push(elem.vietnamese);
          })
        })
        .catch(err => {
          this.$store.commit('edit', false);//关闭全局的loading
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        })

    },
    methods: {
      isNull(a, b, c) {
        switch (c) {
          case 'tips_name':
            if (b == "" || b == null) {
              this.tips_name = true;
            } else {
              this.tips_name = false;
            }
            break;
          case 'tips_zalo':


            if (b == "" || b == null) {
              this.tips_zalo = true;
              this.zalo_check_tel = this.$t('message.must_ipt');
            } else {
              this.tips_zalo = false;
              // if(!(/^\d{9}$|^\d{10}$/.test(b))){//去除84前的‘+’，然后算9位电话是否有0，有就10位，没有就9，然后在加84
              //   this.tips_zalo=true;
              //   this.infos.zalo="";
              //   this.zalo_check_tel='Vui lòng nhập số zalo chính xác';
              // }
            }
            break;
        }
      },
      ipt_tel_number() {
        if (this.infos.zalo.indexOf('+84') == -1) {
          this.zalo_final = '+84' + this.infos.zalo;
          this.infos.zalo = this.zalo_final;
        } else {
        }
      },
      //提交基本信息
      subPerInfo() {
        this.$store.commit('edit', true);//打开全局的loading
        this.infos.userinfo_end_time = Date.now();//获取点击提交的时间
        var data = { //提交数据
          userid: this.tk.userid,
          App_Name: 'Vay Som',
          name: this.infos.name,
          idcard: this.infos.idCard,
          education: this.infos.edu,
          is_married: this.infos.marriey,
          occupation: this.infos.job,
          income_max: this.infos.income,
          income_min: '',
          unit_name: this.infos.company,
          unit_city: this.infos.city,
          unit_address: this.infos.address,
          unit_phone: this.infos.tel,
          sex: this.infos.sex,
          age: this.infos.birthDate,
          lng: '',
          lat: '',
          state: '',
          zalo: this.infos.zalo,
          facebook_url: this.infos.facebook,
          livenessId: '',
          idtrue: false,
          userinfo_start_time: this.infos.userinfo_start_time,
          userinfo_end_time: this.infos.userinfo_end_time
        };
        if (this.infos.idCard!='' && this.infos.name!='' && this.infos.edu != "" && this.infos.marriey != "" && this.infos.income != "" && this.infos.sex != "" && this.infos.zalo != "" && this.infos.facebook != "" && this.facebookTrue == true) {
          //提交基本信息
          postBascInfo(data)
            .then(res => {
              if (res.data.code == 200) {
                let that = this;
                this.$notify({
                  type: 'success',
                  message: this.$t('message.basc_post_success'),
                  onClose: () => {
                    that.$router.push({path: '/home'});
                    this.$store.commit('edit', false);//关闭全局的loading
                    sessionStorage.removeItem('imgUrl1');
                    sessionStorage.removeItem('imgUrl2');
                    sessionStorage.removeItem('imgUrl3');
                    sessionStorage.removeItem('birthdate');
                    sessionStorage.removeItem('baseimgUrl1');
                    sessionStorage.removeItem('baseimgUrl2');
                  }
                });
                this.showLoading = false;
                localStorage.setItem('name', this.infos.name);
                localStorage.setItem('IdCard', this.infos.idCard);
              } else {

                this.$notify({
                  type: 'danger',
                  message: this.$t('message.sub_new_error'),
                  onClose: () => {
                    this.$store.commit('edit', false);//关闭全局的loading
                  }
                });
              }
            })
            .catch(err => {
              this.$store.commit('edit', false);//关闭全局的loading
              if (err.toString().indexOf('timeout') != -1) {
                this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
              }
            })
        } else {
          this.$store.commit('edit', false);//关闭全局的loading
          this.$notify({
            type: 'danger',
            message: this.$t('message.jcNEWS')
          });
          this.infos.name == "" || this.infos.name == null ? this.tips_name = true : this.tips_name = false;
          this.infos.idCard == "" || this.infos.idCard == null ? this.tipIDcard = true : this.tipIDcard = false;//
          this.infos.edu == "" || this.infos.edu == null ? this.tips_edu = true : this.tips_edu = false;
          this.infos.marriey == "" || this.infos.marriey == null ? this.tips_marriey = true : this.tips_marriey = false;
          this.infos.income == "" || this.infos.income == null ? this.tips_income = true : this.tips_income = false;
          this.infos.birthDate == "" || this.infos.birthDate == null ? this.tips_birthDate = true : this.tips_birthDate = false;
          this.infos.zalo == "" || this.infos.zalo == null ? this.tips_zalo = true : this.tips_zalo = false;
          this.infos.facebook == "" || this.infos.facebook == null ? this.tipfb = true : this.tipfb = false;//

        }
      },
      //传递facebook后台验证
      iptFacebook() {
        post_facebook({facebook_url: this.infos.facebook})
          .then(res => {
            if (res.data.code == 200) {
              this.tipfb = false;
              this.facebookTrue = true;
            } else {
              this.tipfb = true;
              this.infos.facebook = "";
              this.facebookTrue = false;
            }
          })
          .catch(err => {
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      },
      showImageTRUE() {
        this.showImage = true
      },
      //检查身份证
      checkID() {
        var regular = /^[0-9]\d*$/;
        if (regular.test(this.infos.idCard)) {
          if (this.infos.idCard.length == 9 || this.infos.idCard.length == 12) {
            // if(this.infos.idCard.length==13){
            this.tipIDcard = false;
          } else {
            this.tipIDcard = true;
            this.infos.idCard = "";
          }
        } else {
          this.tipIDcard = true;
          this.infos.idCard = "";
        }
      },
      showPopimg() {
        this.showimgs = true;
      },
      showdate() {
        this.showDate = true;
      },
      showMarrey(a) {
        this.show = true;
        this.itemName = this.baseNews[a];
        this.infoName = a;
      },
      //选择框滚动时，表单内的值变化
      onChange(picker, value, index) {
        this.infos[this.infoName] = value;
      },
      //确定选择的值
      onConfirm(value, index) {
        this.infos[this.infoName] = value;
        this.show = false;
        this['tips_' + this.infoName] = false;

      },
      onConfirmDate(val) {
        // this.infos.birthDate=value;
        let getYear = val.getFullYear();
        let getMon = val.getMonth() + 1 < 10 ? '0' + (val.getMonth() + 1) : val.getMonth() + 1;
        let getDay = val.getDate() < 10 ? '0' + (val.getDate()) : val.getDate();

        // this.infos.birthDate=getYear+"-"+getMon+"-"+getDay;
        this.infos.birthDate = getDay + "-" + getMon + "-" + getYear;
        this.showDate = false;
        this.tips_birthDate = false;
      },
      //关闭选择框
      onCancel() {
        this.show = false;
        this.showDate = false;
      },
      subPerInfoNext() {
        if (this.infos.name != "" && this.infos.idCard != "" && this.infos.edu != "" && this.infos.marriey != "" && this.infos.income != "" && this.infos.sex != "" && this.infos.birthDate != "" && this.infos.zalo != "" && this.infos.facebook != "" && this.facebookTrue == true) {
          let restRZ = JSON.parse(localStorage.getItem('tempDate'));
          restRZ.education = this.infos.edu;
          restRZ.facebook_url = this.infos.facebook;
          restRZ.idcard = this.infos.idCard;
          restRZ.income_max = this.infos.income;
          restRZ.is_married = this.infos.marriey;
          restRZ.name = this.infos.name;
          restRZ.occupation = this.infos.job;
          restRZ.sex = this.infos.sex;
          restRZ.zalo = this.infos.zalo;
          restRZ.age = this.infos.birthDate;
          localStorage.setItem('tempDate', JSON.stringify(restRZ));//暂存重新认证的数据
          this.$router.push({path: '/perInfoHome/Social', query: {orderid: this.$route.query.orderid}})
        } else {
          this.$notify({
            type: 'danger',
            message: this.$t('message.jcNEWS')
          });
        }

      },
      goBack() {
        this.$router.push({path: '/perInfoHome/photos', query: {orderid: this.$route.query.orderid}})
      }
    },
    computed: {
      btnDisabled(){
        if (this.infos.edu != "" && this.infos.marriey != "" && this.infos.income != "" && this.infos.sex != "" && this.infos.zalo != "" && this.infos.facebook != "" && this.facebookTrue == true) {
          return false;
        } else {
          return  true;
        }
      }
    },
    components: {
      headNav
    },
    watch: {},
    updated() {
      if (!sessionStorage.getItem('restRZ')) {
        // if (this.infos.name != "" && this.infos.idCard != "" && this.infos.edu != "" && this.infos.marriey != "" && this.infos.income != "" && this.infos.sex != "" && this.infos.birthDate != "" && this.infos.zalo != "" && this.infos.facebook != "" && this.facebookTrue == true) {
        //   this.btnDisabled = false;
        // } else {
        //   this.btnDisabled = true;
        // }
      }
    }
  }
</script>

<style scoped lang="scss">
  .btns {
    @include defaultBtn;
    margin: 0.97rem 0 0.23rem;
  }

  /deep/ .van-cell.van-field {
    border-radius: 8px !important;
    border: 1px solid #cccccc !important;
  }

  .container {
    padding: 1.6rem 15px 0;

    .circle {
      width: 0.19rem;
      height: 0.19rem;
      background-color: #D5D5D5;
      border-radius: 0.19rem;
      display: inline-block;
      margin-right: 5px;
    }

    .circle1 {
      width: 0.53rem;
      height: 0.53rem;
      background: $color;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 0.53rem;
    }

    .scsf {
      margin-bottom: 0.71rem;

      & :nth-child(1) {
        font-size: 0.53rem;
        font-weight: 600;
        color: $color;
        margin: 0.36rem 0 0.3rem;
      }

      & :nth-child(2) {
        font-size: 0.37rem;
        font-weight: 300;
        color: #878686;
      }
    }

    .form_item {
      margin-bottom: 0.36rem;

      .form_label {
        color: #000000;
        font-size: 0.45rem;
        font-weight: 500;
        margin-bottom: 0.27rem;

        span {
          color: #FF0300;
          margin-right: 3px;
        }
      }

      .radio_item {
        border-radius: 8px !important;
        border: 1px solid #cccccc !important;
        padding: 12px 16px;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          height: 0.55rem;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/personInfo/bascInfo.vue